module.exports = {"invoice":"Factuur","invoices":"Facturen","number":"Nummer","date":"Datum","amount":"Amount","items":"Invoice items","customer":{"customer":"Klant","name":"Naam","address":"Adres"},"list":{"title":"Facturen","empty":"Geen facturen genvonden","create_first":"Maak uw eerste factuur aan"},"manage":{"edit":"Factuur bewerken","create":"Factuur aanmaken","company_details":"Uw gegevens"},"item":{"product":"Product","price":"Prijs","quantity":"Hoeveelheid","discount":"Korting","vat":"BTW","total":"Totaal"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/invoice.json
// module id = /qHK
// module chunks = 9